import {
  TAnalyticsOfferStatus,
  IAnalyticsProduct,
  IAnalyticsExtraOfferIds,
} from '../../../ServicePickerWidget/types/analytics';
import { EMicrofrontendHostName } from '../../../Microfrontend';

export type TAppAnalyticsPageType = EMicrofrontendHostName | 'webview';

export interface IAppAnalyticsBaseParams {
  name: 'oldevent';
  page?: {
    pageType?: TAppAnalyticsPageType;
    siteType?: EAppAnalyticsSiteType;
    extra?: IAnalyticsExtraOfferIds;
  };
}

export enum EAppAnalyticsSiteType {
  App = 'android/IOS',
  Desktop = 'desktop',
  Mobile = 'mobile',
}

export interface IAppAnalyticsParams<TPageExtraParam> {
  category?: TAnalyticsOfferStatus;
  action: string;
  label?: string;
  products?: Array<IAnalyticsProduct>;
  extra?: IAnalyticsExtraOfferIds | TPageExtraParam;
}

export interface IAppAnalytics {
  send<TPageExtraParam>(params: IAppAnalyticsParams<TPageExtraParam>): void;
}
